// extracted by mini-css-extract-plugin
export default {"item":"OptionList_item__ckoe8","text":"OptionList_text__54taA","arrow":"OptionList_arrow__EHrdk","icon":"OptionList_icon__fYp+S","divider":"OptionList_divider__rNO6h"};